import {Component, Inject, OnInit} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {Asset} from '@app/asset';

@Component({
    selector: 'frog-group-sheet',
    templateUrl: './group-sheet.component.html',
    styleUrls: ['./group-sheet.component.scss'],
    standalone: true,
})
export class GroupSheetComponent implements OnInit {
    constructor(
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: Asset[],
        private _bottomSheetRef: MatBottomSheetRef<GroupSheetComponent>,
    ) {}

    ngOnInit(): void {}

    setIndex(index: number) {
        this._bottomSheetRef.dismiss(index);
    }
}
